<ul>
  <li><i class="fas fa-chevron-left" (click)="goBack()"></i> {{ title }}:</li>
  <li *ngFor="let item of items; let ind = index"><span *ngIf="ind > 0"> > </span> {{ item }}</li>
</ul>
